module.exports = __webpack_public_path__ + "img/at-sign.006caf8b.svg";